import { toast } from 'react-toastify';
import axios from 'axios';
import { FORM_ERROR } from 'final-form';
import _ from 'lodash';
import { API_URLS, USER_CONTEXT } from '../actionTypes';
import setAuthToken from '../../utils/setAuthToken';

export const userPropsAction = (payload) => (dispatch) =>
  dispatch({
    type: USER_CONTEXT.SET_USER_PROPS,
    payload,
  });

export const resetUserPropsAction = () => (dispatch) =>
  dispatch({ type: USER_CONTEXT.RESET_USER_PROPS });

/**
 *
 * @param {object} data
 */
export const basicInformationAction = (data) => async (dispatch) => {
  dispatch(userPropsAction({ isActionLoading: true }));
  setAuthToken();
  try {
    const response = await axios({ ...API_URLS.onboarding.basic, data });
    dispatch({
      type: USER_CONTEXT.BASIC_INFORMATION_SUCCESS,
      payload: { step: 2, ...response.data },
    });
    dispatch(userPropsAction({ isActionLoading: false }));
  } catch (error) {
    dispatch(userPropsAction({ isActionLoading: false }));
    dispatch({ type: USER_CONTEXT.BASIC_INFORMATION_FAILURE });
    const { data } = await error.response;
    if (data && data.errors) {
      return data.errors;
    } else {
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
      return { [FORM_ERROR]: message };
    }
  }
};

/**
 *
 * @param {object} data
 */
export const domainAction = (data) => async (dispatch) => {
  dispatch(userPropsAction({ isActionLoading: true }));
  setAuthToken();
  try {
    const response = await axios({ ...API_URLS.onboarding.domain, data });
    dispatch({
      type: USER_CONTEXT.DOMAIN_SUCCESS,
      payload: { step: 3, ...response.data },
    });
    dispatch(userPropsAction({ isActionLoading: false }));
  } catch (error) {
    dispatch(userPropsAction({ isActionLoading: false }));
    dispatch({ type: USER_CONTEXT.DOMAIN_FAILURE });
    const { data } = await error.response;
    if (data && data.errors) {
      return data.errors;
    } else {
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
      return { [FORM_ERROR]: message };
    }
  }
};

/**
 *
 * @param {object} data
 */
export const locationAction = (data) => async (dispatch) => {
  dispatch(userPropsAction({ isActionLoading: true }));
  setAuthToken();
  try {
    const response = await axios({ ...API_URLS.onboarding.location, data });
    dispatch({
      type: USER_CONTEXT.LOCATION_SUCCESS,
      payload: { step: 4, ...response.data },
    });
    dispatch(userPropsAction({ isActionLoading: false }));
  } catch (error) {
    dispatch(userPropsAction({ isActionLoading: false }));
    dispatch({ type: USER_CONTEXT.LOCATION_FAILURE });
    const { data } = await error.response;
    if (data && data.errors) {
      _.map(data.errors, (value) => toast.error(value));
      return data.errors;
    } else {
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
      return { [FORM_ERROR]: message };
    }
  }
};

/**
 *
 * @param {object} data
 */
export const mobileAction = (data) => async (dispatch) => {
  dispatch(userPropsAction({ isActionLoading: true }));
  setAuthToken();
  try {
    const response = await axios({ ...API_URLS.onboarding.mobile, data });
    dispatch({
      type: USER_CONTEXT.MOBILE_NO_SUCCESS,
      payload: { step: 4.1, ...response.data },
    });
    dispatch(
      userPropsAction({ isMobileSubmitted: true, isActionLoading: false })
    );
    toast.success(
      'A verification code has been sent successfully to your mobile number'
    );
  } catch (error) {
    dispatch(userPropsAction({ isActionLoading: false }));
    dispatch({ type: USER_CONTEXT.MOBILE_NO_FAILURE });
    const { data } = (await error.response) || {};
    if (data && data.errors) {
      _.map(data.errors, (error) => toast.error(error));
      return data.errors;
    } else {
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
      return { [FORM_ERROR]: message };
    }
  }
};

/**
 *
 * @param {object} data
 */
export const mobileVerifyAction = (data) => async (dispatch) => {
  dispatch(userPropsAction({ isActionLoading: true }));
  setAuthToken();
  try {
    const response = await axios({ ...API_URLS.onboarding.verifyMobile, data });
    dispatch({
      type: USER_CONTEXT.MOBILILE_NO_VERIFY_SUCCESS,
      payload: { step: 5, ...response.data },
    });
    dispatch(userPropsAction({ isActionLoading: false }));
  } catch (error) {
    dispatch(userPropsAction({ isActionLoading: false }));
    dispatch({ type: USER_CONTEXT.MOBILILE_NO_VERIFY_FAILURE });
    const { data } = await error.response;
    if (data && data.errors) {
      return data.errors;
    } else {
      const message = data && data.message ? data.message : error.message;
      toast.error(message);
      return { [FORM_ERROR]: message };
    }
  }
};
